__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-03-10-1773146421-stable-dev/";